import { Component, OnInit, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Store } from '@ngrx/store';
import { Title } from '@angular/platform-browser';
import { UserInfoState } from 'src/store/reducers/user-info.reducer';
import { VersionService } from 'src/services/version.service';
import { environment } from 'src/environments/environment';
import packageJson from '../../../../package.json';

@Component({
    selector: 'app-about',
    templateUrl: './about.component.html',
    styleUrls: ['./about.component.scss'],
    // eslint-disable-next-line @angular-eslint/prefer-standalone
    standalone: false,
})
export class AboutComponent implements OnInit {
    public apiVersion = 'Loading...';
    public buildMode = environment.buildMode;
    public title = 'About & Support';
    public webVersion = packageJson.version;

    private http = inject(HttpClient);
    private store = inject<Store<{ user: UserInfoState }>>(Store);

    private titleService = inject(Title);
    private versionService = inject(VersionService);

    public ngOnInit(): void {
        this.titleService.setTitle('About & Support - SesammTool 3');
        this.versionService.getVersion().subscribe({
            next: (data) => (this.apiVersion = data.version),
            error: () => (this.apiVersion = 'N/A'),
        });
    }
}
